import { commonTokens } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { sizes } from "../constants/spacing";
import { ThemeObject } from "./types";
import { getCSSVariables } from "./utils/getCSSVariables";

export const ursaTheme: ThemeObject = {
    key: "ursa-light",
    cssVariables: getCSSVariables("com", "ursa-light", commonTokens),
    skipLink: {
        container: {
            borderRadius: "8px",
            top: `${sizes.small}px`,
            padding: `0 ${sizes.small}px`,
            height: "48px",
            boxShadow: color("elevation--shadow-1"),
            gap: "small",
        },
        button: {
            padding: `0 ${sizes.xSmall}px`,
            fontSize: "14px",
            lineHeight: "18px",
            borderRadius: "6px",
            focusRingGap: 1,
        },
    },
};
